// リンク
import React from 'react';

interface Props {
  display_name: string;
  anchor: string;
  color?: string;
  bold?: boolean;
  css_class?: string;
}

const Link: React.FC<Props> = ({
  display_name,
  anchor,
  color = 'link-green',
  bold,
  css_class = ''
}) => {
  // 太字の設定
  const bold_css = typeof bold !== 'undefined' && bold === true ? 'link-font-bold' : '';

  return (
    <a href={anchor} className={`link-text ${color} ${css_class} ${bold_css}`} target="_blank">
      {display_name}
    </a>
  );
};

export default Link;
